<template>
  <v-dialog
    v-model="confirmDialog"
    persistent
    max-width="600"
    @keydown.esc="closeConfirmDialog"
  >
    <v-card>
      <v-card-title class="title">Save</v-card-title>
      <v-card-text><slot></slot></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-tooltip top>
          <v-btn
            slot="activator"
            :disabled="loading"
            :loading="loading"
            flat
            @click="saveConfirmDialog"
          >
            <v-icon color="green">check</v-icon>
          </v-btn>
          <span>Yes</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn
            slot="activator"
            :disabled="loading"
            :loading="loading"
            flat
            @click="closeConfirmDialog"
          >
            <v-icon color="pink">close</v-icon>
          </v-btn>
          <span>No</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    confirmDialog: Boolean,
    loading: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    saveConfirmDialog() {
      this.$emit("saveConfirmDialog");
    },
    closeConfirmDialog() {
      this.$emit("closeConfirmDialog");
    },
  },
};
</script>

<style></style>
